export * from './HomePage'
export * from './AutoTestPage'
export * from './EvaluTestPage'
export * from './MoreOptions'